module.exports = "MessageFormat.locale.zh=function(n){return \"other\"}\n"